import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { DBDef_AdvisorSnippet, DBDef_AdvisorWizard, } from '@app/advisor-content-shared';
import { currentTimeMillis, filterInstances, md5 } from '@nu-art/ts-common';
import { ModuleFE_Advisor_ContextRule } from './healthcare-space.js';
export const dispatch_onAdvisorWizardsUpdated = new ThunderDispatcherV3('__onAdvisorWizardsUpdated');
class ModuleFE_Advisor_AdvisorWizard_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_AdvisorWizard, dispatch_onAdvisorWizardsUpdated);
        this.registerVersionUpgradeProcessor('1.0.2', this.upgrade_102);
    }
    upgrade_102 = async (items) => {
        items.forEach(item => {
            item.steps.forEach(step => {
                const newStep = step;
                newStep.snippets = step.snippetIds?.map(id => ({ snippetId: id })) ?? [];
                newStep.searchData.snippets = step.searchData.snippetIds?.map(id => ({ snippetId: id })) ?? [];
                newStep.freeTextData.snippets = step.searchData.snippetIds?.map(id => ({ snippetId: id })) ?? [];
                newStep.formData.snippets = step.searchData.snippetIds?.map(id => ({ snippetId: id })) ?? [];
                //Delete old data
                delete step.snippetIds;
                delete step.freeTextData.snippetIds;
                delete step.searchData.snippetIds;
                delete step.formData.snippetIds;
            });
        });
    };
}
export const ModuleFE_Advisor_AdvisorWizard = new ModuleFE_Advisor_AdvisorWizard_Class();
export const dispatch_onAdvisorSnippetsUpdated = new ThunderDispatcherV3('__onAdvisorSnippetsUpdated');
class ModuleFE_Advisor_AdvisorSnippet_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_AdvisorSnippet, dispatch_onAdvisorSnippetsUpdated);
        this.registerVersionUpgradeProcessor('1.0.8', this.upgrade_108);
    }
    upgrade_108 = async (advisorSnippets) => {
        const rulesToUpsert = [];
        for (const item of advisorSnippets) {
            // get rules
            const rules = [...item.rules ?? []];
            const excludedVariableIds = [...item.excludedVariableIds ?? []];
            // remove irrelevant fields
            delete item.__tagIds;
            delete item.excludedVariableIds;
            delete item.rules;
            // otherwise create a context rule entity
            const currentTime = currentTimeMillis();
            const newContextRule = {
                _id: md5(`${item._id}-${item.label}`), // this will work out just fine! the fact this one is consistent allows me to do it knowing the id will work
                label: item.label,
                excludedVariableIds: excludedVariableIds,
                rules,
                _tagIds: filterInstances(rules.flatMap(rule => rule.tagIds)),
                _v: '1.0.0',
                __updated: currentTime,
                __created: currentTime
            };
            // add the new rule to the list of new rules to update cache with
            rulesToUpsert.push(newContextRule);
            // set the new db rules id for the snippet
            item.contextRuleId = newContextRule._id;
        }
        await ModuleFE_Advisor_ContextRule.onEntriesUpdated(rulesToUpsert);
    };
}
export const ModuleFE_Advisor_AdvisorSnippet = new ModuleFE_Advisor_AdvisorSnippet_Class();
export const ModulePack_Static_AdvisorContext = [
    ModuleFE_Advisor_AdvisorWizard,
    ModuleFE_Advisor_AdvisorSnippet,
];
//# sourceMappingURL=advisor-context.js.map